<template>
  <span>
    批量导入成功 <span style="color: #19be6b">{{ submits.length }}</span
    >个，失败<span style="color: #ed4014"> {{ len }} </span>个
    <ins style="word-break: break-all">
      ，失败账号名称为：
      <ins v-if="errs.length > 15">
        <code v-for="err of miniErr" :key="err">{{ err }}</code
        >...等
        <a
          href="javascript:;"
          style="white-space: nowrap; margin-left: 8px"
          v-clipboard:copy="codeErrStr"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制失败</a
        >
      </ins>
      <ins v-else>
        <code v-for="err of errs" :key="err">{{ err }}</code>
        <a
          href="javascript:;"
          style="white-space: nowrap; margin-left: 8px"
          v-clipboard:copy="codeErrStr"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          >复制失败</a
        >
      </ins>
    </ins>
  </span>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      default() {
        return []
      }
    },
    submits: {
      type: Array,
      default() {
        return []
      }
    },
    errs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    codeErrStr() {
      return this.errs.join('\r\n')
    },
    miniErr() {
      return this.errs.filter((e, i) => i < 15)
    },
    len() {
      return this.tags.length - this.submits.length
    }
  },
  methods: {
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    }
  }
}
</script>
<style lang="scss" scoped>
code {
  color: #232323;
  background-color: #f1f1f1;
  padding-left: 4px;
  padding-right: 4px;
  margin-left: 5px;
  font-family: Consolas, 'courier new';
  font-size: 110%;
}
</style>
